import React, { useState } from 'react';
import { Anohana, Bx, Btn, IconBtn, Typo } from '@curry-group/mui-curcuma';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowToRight, faTimes } from '@fortawesome/pro-light-svg-icons';
import { HeadlineContainer } from '../../../headline-container';
import { useDispatch } from 'react-redux';
import { FormInput } from '../../../form/controls/input';
import { pinMessageRequest } from '../../../../data/reducer/communication';

export const PinMessagePopup: React.FC<{
  parentId: string;
  messageId: string;
  open: boolean;
  close?: () => void;
  cancel?: () => void;
}> = ({
  parentId,
  messageId,
  open,
  close,
  cancel,
}) => {
  const dispatch = useDispatch();
  const [statement, setStatement] = useState('');
  const dispatcher = {
    pinMessage: (parentId: string, messageId: string, message?:string) =>
      dispatch(pinMessageRequest({
        id: parentId || '',
        messageId: messageId || '',
        message: message
    })),
  };
  return (
    <Anohana open={open} fullWidth maxWidth="sm">
      <HeadlineContainer
        bgcolor="background.paper"
        px={3}
        py={2.5}
        headline={'Bannertext für angeheftete Nachricht festlegen'}
        minHeight={81}
        headlineVariant="h4"
        headlineComponent="h5"
        endAdornment={<IconBtn size="small" onClick={close}><FontAwesomeIcon icon={faTimes} /></IconBtn>}
      />
      <Bx py={3} px={3}>
        <Bx mt={2}>
          <FormInput
            value={statement}
            label={'Bannertext'}
            placeholder={'Eingabe für den alternativen Text.'}
            minLength={0}
            maxLength={2500}
            multiline={true}
            onChange={val => {
              setStatement(val);
            }}
            successMessage={''}
            lazy
          />
        </Bx>
        <Bx mt={4} display="flex" justifyContent="flex-end" alignItems="center">
          <Bx>
            <Btn
              onClick={() => {
                dispatcher.pinMessage(parentId, messageId, statement);
              }}
              color="success"
              size="large"
              variant="contained"
              startIcon={<FontAwesomeIcon icon={faArrowToRight} />}
            >
              Nachricht anheften
            </Btn>
          </Bx>
          <Bx ml={1}>
            <Btn onClick={cancel} color="error" size="large" variant="contained" startIcon={<FontAwesomeIcon icon={faTimes} />}>
              Abbrechen
            </Btn>
          </Bx>
        </Bx>
      </Bx>
    </Anohana>
  );
};
